import { jsx as _jsx } from "react/jsx-runtime";
import { isAbsoluteURL, LinkTarget } from '@prophecy/utils/url';
import ReactMarkdown from 'react-markdown';
import rehypeExternalLinks from 'rehype-external-links';
import remarkGfm from 'remark-gfm';
import styled from 'styled-components';
import { UI_TYPOGRAPHY_ROOT_CLASS } from '../theme';
import { mentionPlugin, MentionComponent } from './mentionPlugin';
import remarkUnderlineHtml from './underlinePlugin';
import { unwrapInlineMentionCodePlugin } from './unwrapInlineMentionCodePlugin';
const linkTarget = ({ properties })=>{
    return isAbsoluteURL(properties.href) ? LinkTarget._blank : LinkTarget._self;
};
const StyledImage = styled.img`
  max-width: 100%;
  height: auto;
`;
export default function Markdown({ children: markdownContent, className, remarkPlugins, renderMention, ...restProps }) {
    const remarkPluginsList = remarkPlugins || [];
    // Add custom mention renderer component
    const components = {
        mention: (props)=>/*#__PURE__*/ _jsx(MentionComponent, {
                mentionText: props.mentionText,
                className: "markdown-mention",
                renderMention: renderMention
            }),
        u: (props)=>/*#__PURE__*/ _jsx("u", {
                ...props
            }),
        img: (props)=>/*#__PURE__*/ _jsx(StyledImage, {
                ...props
            }),
        ...restProps.components
    };
    return /*#__PURE__*/ _jsx(ReactMarkdown, {
        ...restProps,
        className: `${UI_TYPOGRAPHY_ROOT_CLASS} ${className || ''}`,
        components: components,
        rehypePlugins: [
            [
                rehypeExternalLinks,
                {
                    target: linkTarget,
                    rel: [
                        'nofollow',
                        'noopener'
                    ]
                }
            ]
        ],
        remarkPlugins: [
            remarkGfm,
            unwrapInlineMentionCodePlugin,
            mentionPlugin,
            remarkUnderlineHtml,
            ...remarkPluginsList
        ],
        children: markdownContent?.replace(/\n/g, '  \n')
    });
}
